import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Route, Routes } from 'react-router-dom-v5-compat';

import { ResolvedComponent } from './RouteResolvedComponent';
import { getRoutes } from './routes';
import { useBrowserTitle } from './useBrowserTitle';
import { useTrackPage } from './useTrackPage';

interface NestedRouteConfig {
  path: string;
  component: React.ComponentType;
}

export function Router() {
  const intl = useIntl();

  useBrowserTitle();
  useTrackPage();

  const routes = useMemo(() => {
    return Object.values(getRoutes(intl)).map((route) => {
      const { path, nestedRoutes } = route;
      if (nestedRoutes) {
        return (
          <Route
            key={path}
            path={path}
            element={<ResolvedComponent route={route} />}
          >
            {(nestedRoutes as unknown as NestedRouteConfig[]).map(
              ({ path, component: Component }) => (
                <Route key={path} path={path} element={<Component />} />
              ),
            )}
          </Route>
        );
      }

      return (
        <Route
          key={path}
          path={path}
          element={<ResolvedComponent route={route} />}
        />
      );
    });
  }, [intl]);

  return <Routes>{routes}</Routes>;
}

export default Router;
